<template>
  <div class="login-wrap">
    <div class="row">
      <div class="col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t">
        <img src="../../assets/images/logo-login.png" alt="">
        <h2 class="push-50-t">{{ labelFieldTitle[actualLanguage] }}</h2>
        <br>
        <router-link type="button" class="link-effect" :to="{name: 'login'}">
         <h5 class="font-w700 push" >{{ labelFieldGoHome[actualLanguage] }}</h5>
        </router-link>
        <div v-if="errorMsg" class="alert push-30-t alert-danger alert-dismissable">
          <p>{{errorMsg}}</p>
        </div>
        <div v-if="notif" class="alert push-30-t alert-success alert-dismissable">
          <p>{{notif}}</p>
        </div>


        <form class="simple_form form-horizontal push-50-t" novalidate="novalidate" id="new_user"
              action="/lobby/connexion" accept-charset="UTF-8" method="post"><input name="utf8" type="hidden" value="✓"><input
          type="hidden" name="authenticity_token"
          value="Ahic++4LN7D6ofsViOL59IWMgE7/qyXEiqG8ApI4fBU+CXupmcktQPQ19HxfIKmW2lGSWB4L+DcKWi9eQQPY/g==">
          
          <div class="form-inputs">
            <div class="form-group">
              <div class="col-xs-12 ">
                <div class="form-material form-material-primary">
                  <input :disabled="isWorking" v-model="email" class="form-control string email optional form-control"
                         autofocus="autofocus" type="email" value="" name="user[email]" id="user_email">
                  <label for="user_email">{{ labelFieldEmail[actualLanguage] }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 push">
            <div class="form-actions push">
              <div class="col-xs-12 text-center push">
                  <button v-if="!isWorking" type="button" @click="forgotPasswordStep01" style="min-width: 250px" class="btn btn-connexion btn-success">
                    {{ labelFieldButtonSendCode[actualLanguage] }}
                  </button>
                <spinner v-else></spinner>
              </div>
            </div>
          </div>


          <div v-if="displayCodeInput" class="col-xs-12 push">
            <div  class="col-xs-12 push-30-t">
              
              <h6 class="font-w700 push-50-t" >{{ emailSentMessage[actualLanguage] }}</h6>
              <div class="form-group">
                
                <div class="col-xs-12 push-30-t">
                  <div class="form-material form-material-primary">
                    <input :disabled="isWorking" v-model="confirmationCode" class="form-control string email optional form-control"
                          autofocus="autofocus" type="email" value="" name="code" id="code">
                    <label for="code">{{ labelFieldConfirmationCode[actualLanguage] }}</label>
                  </div>
                </div>
              </div>

              <h6 class="font-w700 push-50-t" >{{ passwordConditionMessage[actualLanguage] }}</h6>
              <div class="form-group">
                
                <div class="col-xs-12 push-30-t">
                  <div class="form-material form-material-primary">
                    <input :disabled="isWorking" v-model="newPassWord" class="form-control password optional form-control"
                          autofocus="autofocus" type="password" value="" name="password" id="password">
                    <label for="code">{{ labelNewPW[actualLanguage] }}</label>
                  </div>
                </div>
              </div>

              <div class="form-actions">
                <div class="col-xs-12 text-center push-30-t">
                    <button v-if="!isWorking" type="button" @click="forgotPasswordStep02" style="min-width: 250px" class="btn btn-connexion btn-success">
                      {{ labelBtnApplyNewPW[actualLanguage] }}
                    </button>
                  <spinner v-else></spinner>
                </div>
              </div>

            </div>
          </div>


          <div class="row">
            <div class="col-sm-12 text-center" style="margin-top: 100px">
              <p>{{ labelFieldTextFirstTime[actualLanguage] }}
                <router-link style="margin-left: 5px" class="btn btn-default btn-rounded" :to="{name: 'register'}">
                  {{ labelFieldButtonSubscribe[actualLanguage] }}
                </router-link>
              </p>
            </div>
          </div>

          <div class="form-actions">
            <div class="col-xs-12 text-center push-30-t">
              <button v-if="!isWorking" type="button" @click="toggleLanguage" style="min-width: 250px"
                      class="btn btn-default btn-rounded">{{ labelFieldButtonLanguage[actualLanguage] }}
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from '../../components/Spinner'
  import {mapState} from "vuex";

  export default {
    components: {
      Spinner
    },
    name: "ForgotPW",
    data() {
      return {
        email: '',
        isWorking: false,
        errorMsg: '',
        notif: '',

        displayCodeInput:false,
        confirmationCode:'',
        newPassWord:'',


        labelFieldTitle: {FR: 'Mot de passe oublié', EN: 'Forgot password'},
        actualLanguage: "FR",
        labelFieldButtonLanguage: {FR: 'English version', EN: 'Version française'},
        labelFieldEmail: {FR: 'Adresse courriel', EN: 'Email'},
        labelFieldTextFirstTime: {FR: "C'est votre première fois ?", EN: 'This is your first time ?'},
        labelFieldButtonSubscribe: {FR: 'Inscription', EN: 'Subscribe'},
        labelFieldButtonForgotPW: {FR: 'Mot de passe oublié?', EN: 'Forgot password?'},
        labelFieldButtonSendCode: {FR: 'Envoyer le code de confirmation', EN: 'Send confirmation code'},
        labelFieldGoHome: {FR: 'Revenir à la page d\'accueil', EN: 'Go back to home page'},

        labelFieldConfirmationCode: {FR: 'Code de confirmation', EN: 'Confirmation code'},
        emailSentMessage:{FR: "Un code de confirmation de compte a été envoyé à l'adresse courriel, introduisez le code reçu. (Consultez votre dossier de courrier indésirable si le courrier n'apparaît pas dans votre boîte de réception)",
                           EN: "An account confirmation code has been sent to the email address, please enter the receved code. (Check your spam folder if the email doesn't appear in your inbox.)"},
 
        passwordConditionMessage:{FR: "Introduisez votre nouveau mot de passe (doit contenir un minimum de 8 caractères).",
                           EN: 'Enter your new password (must contain a minimum of 8 characters).'},
        labelNewPW: {FR: 'Nouveau mot de passe', EN: 'New password'},
        labelBtnApplyNewPW: {FR: 'Enregistrer le nouveau mot de passe', EN: 'Apply new password'},

      }
    },

    computed: {
      ...mapState('sessionStore', ['userEmail']),
    },

    mounted() {
      this.isWorking = false
      if (this.$router.currentRoute.params.notif) {
        this.notif = this.$router.currentRoute.params.notif
      }

      if (localStorage.language) {
        this.actualLanguage = localStorage.language
      } else {
        this.actualLanguage = 'FR'
      }
    },

    methods: {
      forgotPassword() {
        this.isWorking = true
        this.$store.dispatch('sessionStore/forgotPassword', {email: this.email, language: this.actualLanguage})
          .then(()=>{
            this.$router.push({name: "login"})
        })
          .catch((e) => {
          this.errorMsg = e.message;
          this.isWorking = false
        })

      },


      forgotPasswordStep01() {
        this.isWorking = true
        this.$store.dispatch('sessionStore/forgotPasswordStep01', {email: this.email, language: this.actualLanguage})
          .then(()=>{
            this.displayCodeInput = true
            this.isWorking = false
            this.errorMsg = ""

            this.labelFieldButtonSendCode.FR= 'Envoyer un nouveau code de confirmation'
            this.labelFieldButtonSendCode.EN= 'Send new confirmation code'

        })
          .catch((e) => {
          this.errorMsg = e.message;
          this.isWorking = false
        })

      },

      forgotPasswordStep02() {
        this.isWorking = true
        this.$store.dispatch('sessionStore/forgotPasswordStep02', {email: this.email, language: this.actualLanguage, verificationCode: this.confirmationCode, newPassword:this.newPassWord})
          .then(()=>{
            this.$router.push({name: "login"})
        })
          .catch((e) => {
          this.errorMsg = e.message;
          this.isWorking = false
        })

      },


      toggleLanguage() {
        if (this.actualLanguage == 'FR') {
          this.actualLanguage = 'EN'
          localStorage.language = 'EN'
        } else {
          this.actualLanguage = 'FR'
          localStorage.language = 'FR'
        }
        location.reload()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ForgotPW.vue?5728ccae